export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/page/login/index')
  },
  // {
  //   path: '/testReport',
  //   name: '检测报告',
  //   component: () => import('@/views/client/testReport/reportPreview')
  // },
  {
    path: '/401',
    name: '401',
    component: () => import('@/page/error/401')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/page/error/404')
  },
  {
    path: '/',
    name: 'layout'
  }
]
